// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pYWKnF0xsr8vqKIR {
    display: flex;
    align-items: center;
    justify-content: space-around;

    overflow: hidden;
    width: 100%;
    padding: var(--lok-spacing-9) var(--lok-spacing-10);
    background-color: var(--lok-color-background-surface-middle);
    gap: var(--lok-spacing-12);

    container-type: inline-size;
}

.VeKeWjQ1w_Izr9n_ {
    display: flex;
    flex-direction: column;
    gap: var(--lok-spacing-2);
    height: 100%;
    max-width: 350px;
}

.RKCYa1oRg8qUvc46 {
    font: var(--lok-typography-heading-3);
}

.ow4nbWr4zAvQ6vNA {
    font: var(--lok-typography-body-tiny-default);
}

.mItKpcZW4MCDUQqX {
    color: var(--lok-color-text-success);
    font: var(--lok-typography-body-small-default);
}

.kdSe5IRLibUqNaQV {
    color: var(--lok-color-text-link-default);
    font: var(--lok-typography-body-small-default);
}

.h_8MHAVg66QwdYi5 {
    display: flex;
    flex-direction: column;
    gap: var(--lok-spacing-2);
    max-width: 240px;
}

.F_KYBflxhw8wQNvH {
    color: var(--lok-color-text-disabled);
    font: var(--lok-typography-body-tiny-default);
}

.wpXCdHcvKi8E11sY.wpXCdHcvKi8E11sY {
    background-color: var(--lok-color-background-surface-default);
    box-shadow: 0px 10px 20px 2px #26262605,
        0px 8px 16px 0px #2626260A,
        0px 4px 6px 0px #2626260A,
        0px 0px 2px 0px #2626261A;
}

@container (width < 860px) {
    .cfPT6_UmhdwuMeZT {
        display: none;
    }
}`, "",{"version":3,"sources":["webpack://./packages/rag/src/components/LandingPageBanner/components/BannerComponents.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;;IAE7B,gBAAgB;IAChB,WAAW;IACX,mDAAmD;IACnD,4DAA4D;IAC5D,0BAA0B;;IAE1B,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,oCAAoC;IACpC,8CAA8C;AAClD;;AAEA;IACI,yCAAyC;IACzC,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;IACrC,6CAA6C;AACjD;;AAEA;IACI,6DAA6D;IAC7D;;;iCAG6B;AACjC;;AAEA;IACI;QACI,aAAa;IACjB;AACJ","sourcesContent":[".container {\n    display: flex;\n    align-items: center;\n    justify-content: space-around;\n\n    overflow: hidden;\n    width: 100%;\n    padding: var(--lok-spacing-9) var(--lok-spacing-10);\n    background-color: var(--lok-color-background-surface-middle);\n    gap: var(--lok-spacing-12);\n\n    container-type: inline-size;\n}\n\n.textContainer {\n    display: flex;\n    flex-direction: column;\n    gap: var(--lok-spacing-2);\n    height: 100%;\n    max-width: 350px;\n}\n\n.header {\n    font: var(--lok-typography-heading-3);\n}\n\n.body {\n    font: var(--lok-typography-body-tiny-default);\n}\n\n.subHeader {\n    color: var(--lok-color-text-success);\n    font: var(--lok-typography-body-small-default);\n}\n\n.subHeader_blue {\n    color: var(--lok-color-text-link-default);\n    font: var(--lok-typography-body-small-default);\n}\n\n.ctaContainer {\n    display: flex;\n    flex-direction: column;\n    gap: var(--lok-spacing-2);\n    max-width: 240px;\n}\n\n.ctaSubText {\n    color: var(--lok-color-text-disabled);\n    font: var(--lok-typography-body-tiny-default);\n}\n\n.secondaryButton.secondaryButton {\n    background-color: var(--lok-color-background-surface-default);\n    box-shadow: 0px 10px 20px 2px #26262605,\n        0px 8px 16px 0px #2626260A,\n        0px 4px 6px 0px #2626260A,\n        0px 0px 2px 0px #2626261A;\n}\n\n@container (width < 860px) {\n    .hideableContainer {\n        display: none;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `pYWKnF0xsr8vqKIR`,
	"textContainer": `VeKeWjQ1w_Izr9n_`,
	"header": `RKCYa1oRg8qUvc46`,
	"body": `ow4nbWr4zAvQ6vNA`,
	"subHeader": `mItKpcZW4MCDUQqX`,
	"subHeader_blue": `kdSe5IRLibUqNaQV`,
	"ctaContainer": `h_8MHAVg66QwdYi5`,
	"ctaSubText": `F_KYBflxhw8wQNvH`,
	"secondaryButton": `wpXCdHcvKi8E11sY`,
	"hideableContainer": `cfPT6_UmhdwuMeZT`
};
export default ___CSS_LOADER_EXPORT___;
